import { SET_OPEN_GLOBLE_ADD_MENU } from '../reducers/action';

export const acSetOpenGlobleAddMenu = (value) => ({
  type: SET_OPEN_GLOBLE_ADD_MENU,
  payload: value,
});
